import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const Bullet = (
    <span
        style={{
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)'
        }}
    >
        •
    </span>
);

const Login = ({ authUrl }) => (
    <Card style={{ width: 500 }}>
        <CardContent>
            <Typography style={{ marginBottom: 16, fontSize: 14 }} color="textSecondary">
                Chemaxon
            </Typography>
            <Typography variant="headline" component="h2">
                in{Bullet}sid{Bullet}er
            </Typography>
            <Typography style={{ marginBottom: 12 }} color="textSecondary">
                noun
            </Typography>
            <Typography component="p">
                One in possession of special information by virtue of being within some organization.
            </Typography>
        </CardContent>

        <CardActions>
            <Button size="medium" variant="contained" color="primary" href={authUrl}>
                Log{Bullet}in
            </Button>
        </CardActions>
    </Card>
);

Login.propTypes = {
    authUrl: PropTypes.string
};

ReactDOM.render(
    <Login authUrl={document.head.querySelector('[property=authUrl]').content} />,
    document.getElementById('login')
);
